import { GET_ALL_DESIGNATION } from "../services/apiUrls";
import { get } from "../services/service";

export const fetchAllDesignation = async (tenantId) => {
  let response = await get(GET_ALL_DESIGNATION.replace("{tenantId}", tenantId));
  return response;
};
